module.exports = ({
    "CDMS500MSG001": "ไม่สามารถกรอกข้อมูลในหน้านี้ได้ เนื่องจากหน้าลงทะเบียนมีอยู่แล้ว",
    "CDMS500MSG002": "คุณแน่ใจหรือไม่ว่าต้องการลบนัดหมายที่เลือก",
    "CDMS500MSG003": "คุณแน่ใจหรือไม่ว่าต้องการเรียกคืนการนัดหมาย (visit) ที่ลบไป",
    "CDMS500MSG004": "ไม่สามารถเพิ่มการนัดหมาย {item} ได้เนื่องจากไม่มีหน้าใดที่พร้อมใช้งาน",
    "CDMS500BTN001": "รายการผู้เข้าร่วมวิจัย",
    "CDMS500BTN002": "เพิ่มการนัดหมาย",
    "CDMS500BTN003": "เลือกการนัดหมายนอกจากการนัดหมายที่กำหนดไว้",
    "CDMS500TT001": "เพิ่มการนัดหมาย",
    "CDMS500TT002": "เลือกการนัดหมายที่ไม่ได้กำหนดไว้",
    "CDMS500TT003": "Visit&Form Matrix",
    "CDMS500LB001": "จำนวนนอกการนัดหมาย "
});